import ApplicationAdapter from './application';
import DS from 'ember-data';

const { InvalidError } = DS;

export default class ApiCredentialAdapter extends ApplicationAdapter {
  handleResponse(status, headers, payload) {
    if (status !== 409) {
      return super.handleResponse(...arguments);
    }

    let error = payload.errors.find((e) => /credentials.*already exist/i.test(e.detail));

    if (!error) {
      return super.handleResponse(...arguments);
    }

    // turn 409 (conflict) response into generic invalid model error
    // 409 in case of environments is caused by non-unique name - it can be turned into "name" attribute error
    error.detail = 'Choose a new name. This one already exists for this workspace.';
    error.source = { pointer: '/data/attributes/name' };
    return new InvalidError(payload.errors);
  }

  buildURL(modelName, id, snapshot, requestType, query) {
    let url = super.buildURL(modelName, id, snapshot, requestType, query);

    // pass-through account scope paths for GET requests:
    // necessary due to API credentials views in UI being on account level (unknown environment)
    if (['findAll', 'findRecord', 'query'].includes(requestType)) {
      return url;
    }

    // for all other operations, use env. ID set on the model:
    let envID = snapshot.belongsTo('environment').id;
    url = `${this.host}/${this.namespace}/environments/${envID}/api_credentials`;

    if (id) {
      url += `/${id}`;
    }

    return url;
  }
}
